import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  min-width:300px;
  min-height: 200px;
  justify-content: center;
  flex-direction: row;
  padding: 1rem;
  gap: 1rem;

  .box{
    display: flex;
    width: 20rem;
    min-width: 250px;
    height: 100%;
    flex-direction: column;
    border-radius: 4px;
    background-color: #ffffff;
    border: 1px solid #82878b33;

    span{
      display: flex;
      width: 100%;
      height: 2.5rem;
      justify-content: center;
      align-items: center;
      background-color: #f6f6f6;
      border-bottom: 1px solid #82878b33;
    }

    .search--{
      height: 3rem;
      border-radius: 0px;
    }
  }
  .controls{
    display: flex;
    width: 3rem;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.75rem;
    
    span{
      display: flex;
      width: 2.5rem;
      height: 2.5rem;
      justify-content: center;
      align-items: center;
      font-size: 1.2rem;
      border-radius: 4px;
      color: #ffffff;
      background-color: #1D86FF;
      cursor: pointer;
    }

    .none{
      opacity: 0.7;
      pointer-events: none;
    }
  }
`
export const Options = styled.ul`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  &::-webkit-scrollbar{
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-thumb{
    background-color: rgb(0, 0, 0,0.2);
  }

  li{
    display: flex;
    cursor: pointer;
    &:hover{
      background-color: #1D86FF9c;
    }
  }

  .select{
    border: 1px solid #1D86FF;
    background-color: #1D86FF9c;
  }

`